import React from 'react';

interface State { error: Error | null }

// Catches a crash while a page is drawing so the user sees a message and a way
// out instead of a blank white screen. The real error is still logged to the
// browser console for debugging.
export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('UI crashed:', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: 'system-ui, sans-serif', textAlign: 'center' }}>
        <div style={{ maxWidth: 360 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Something went wrong</h2>
          <p style={{ fontSize: 14, color: '#71717a', marginBottom: 20 }}>
            This page hit an error. Your data is safe. Try again, or go back to your dashboard.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: '10px 18px', borderRadius: 12, border: 0, background: '#e11d48', color: '#fff', fontWeight: 700, marginRight: 8, cursor: 'pointer' }}
          >
            Reload
          </button>
          <a href="/dashboard" style={{ padding: '10px 18px', borderRadius: 12, border: '1px solid #e4e4e7', color: 'inherit', fontWeight: 700, textDecoration: 'none' }}>
            Dashboard
          </a>
        </div>
      </div>
    );
  }
}
